var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconPendingRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6664 1.85938V3.71104C16.6906 4.20604 19.5414 7.86354 19.0464 11.8877C18.6247 15.2244 16.0031 17.8735 12.6664 18.2677V20.101C17.7081 19.5969 21.3747 15.1235 20.8706 10.0819C20.4581 5.72771 17.0022 2.29021 12.6664 1.85938ZM10.8331 1.88687C9.04557 2.06104 7.34057 2.74854 5.94724 3.90354L7.25807 5.26021C8.28474 4.43521 9.52224 3.90354 10.8331 3.72021V1.88687ZM4.65474 5.19604C3.50859 6.58694 2.80326 8.28804 2.62891 10.0819H4.46224C4.63641 8.78021 5.14974 7.54271 5.96557 6.50687L4.65474 5.19604ZM2.63807 11.9152C2.82141 13.7119 3.52724 15.4077 4.66391 16.801L5.96557 15.4902C5.15609 14.454 4.64003 13.2193 4.47141 11.9152H2.63807ZM7.25807 16.8377L5.94724 18.0935C7.33579 19.251 9.03574 19.9718 10.8331 20.1652V18.3319C9.52902 18.1632 8.29428 17.6472 7.25807 16.8377ZM12.2081 6.41521V11.2277L16.3331 13.6752L15.6456 14.8027L10.8331 11.9152V6.41521H12.2081Z",
    fill: "#1C2428",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconPendingRisk);
export default __webpack_public_path__ + "static/media/TH-Icon-Pending-Risk.1f922892a7e742be475557dcd9bee39a.svg";
export { ForwardRef as ReactComponent };